import { render } from "./blog.vue?vue&type=template&id=0a12452e"
import script from "./blog.vue?vue&type=script&lang=js"
export * from "./blog.vue?vue&type=script&lang=js"

import exportComponent from "F:\\hatem\\vue\\sanhory\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__